import React from "react";
import ReactIcon from "../assets/skillicons/react.svg";
import Python from "../assets/skillicons/python.png";
import NodeJs from "../assets/skillicons/nodejs.png";
import MongoDb from "../assets/skillicons/mongodb.png";
import JS from "../assets/skillicons/javascript.png";
import CSS from "../assets/skillicons/css.png";
import Bootstrap from "../assets/skillicons/bootstrap.svg";
import AdobeXD from "../assets/skillicons/adobe-xd.png";
import Figma from "../assets/skillicons/figma.png";
import MySql from "../assets/skillicons/mysql.png";
import Cplus from "../assets/skillicons/c++.png";
import C from "../assets/skillicons/c.png";

const Skillicons = () => {
  return (
    <React.Fragment>
      <h4 className="ml-4 mb-4">Worked with...</h4>
      <div className="card-deck skill-card ml-4 mb-4">
        <div className="cards skills">
          <img src={ReactIcon} alt="reactlogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={Python} alt="pythonlogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={NodeJs} alt="nodejslogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={MongoDb} alt="mongodblogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={JS} alt="jslogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={CSS} alt="csslogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={Bootstrap} alt="bootstraplogo" />
        </div>
        <div className="cards skills">
          <img src={AdobeXD} alt="adobexdlogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={Figma} alt="figmalogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={MySql} alt="mysqlogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={Cplus} alt="cpluslogo" loading="lazy" />
        </div>
        <div className="cards skills">
          <img src={C} alt="clogo" loading="lazy" />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Skillicons;
